export default () => {
    return {
        // Technical fields
        showSavedData: true,
        showLoadingModal: false,
        showErrorModal: false,
        showUnauthorizedModal: false,
        showDisclaimerModal: true,
        showNoDiagnoseFoundModal: false,
        actionToRetry: undefined,

        diagnosestellungReachable: false,
        therapieReachable: false,
        showAnfaelleOverview: true,
        showUntersuchungenOverview: true,


        // Actual data
        patient: {
            id: undefined,
            firstName: undefined,
            lastName: undefined,
            sex: undefined,
            birthDate: undefined,
            caseNumber: undefined,
            patientId: undefined
        }

        // ... the data if the individual tabs is inside of modules
    }
}